<div class="ceo-page-container">
    <h1 class="sr-only">CIO's Desk</h1>
    <div class="align-h article-category-dropdown--container">
        <div class="stretch form-group margin-bottom-0">
            <!--  appearance="standard" temp -->
            <mat-form-field class="stretch article-category-dropdown">
                <mat-select
                    disableOptionCentering
                    [(ngModel)]="selectedCategory"
                    name="category"
                    #category="ngModel" 
                    (selectionChange)="onCategoryChange($event)">
                    <mat-option class="font-16" *ngFor="let category of categories" [value]="category">
                    {{category}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <button mat-icon-button (click)="toggleFilter()">
            <img matSuffix src="assets/icons/filter.png" />
        </button>
    </div>
    <!----FILTER VIEW-->
    <div *ngIf="showFilter" class="article-filter--container">
        <div class="filter-by-year-month-item">
            <!-- Select Year -->
            <div class="form-group year-selection">
                <!-- appearance="standard" temp -->
                <mat-form-field >
                    <label for="mobile-year-select" class="filter-field-label"> Year </label>
                    <mat-select
                        id="mobile-year-select"
                        disableOptionCentering
                        placeholder="Year"
                        [(ngModel)]="selectedYear"
                        name="year"
                        #year="ngModel" 
                        (selectionChange)="globalFiterByYearMonth($event)">
                        <mat-option class="font-16" *ngFor="let year of years" [value]="year.year">
                        {{ year?.year }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Select Month -->
            <div class="form-group month-selection">
                <!-- appearance="standard" temp -->
                <mat-form-field >
                    <label for="mobile-month-select" class="filter-field-label"> Month </label>
                    <mat-select
                        id="mobile-month-select" 
                        disableOptionCentering
                        placeholder="Month"
                        [(ngModel)]="selectedMonth"
                        name="month"
                        #month="ngModel" 
                        (selectionChange)="globalFiterByYearMonth($event)">
                        <mat-option class="font-16" *ngFor="let month of months" [value]="month.month">
                            {{ month?.month }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="sr-only"
                role="status"
                aria-atomic="true">

                {{ liveMessage }}

            </div>
        </div>
    </div>
    <div class="ceo-tab-item-container">
                    <!--Featured Tab List-->
                    <div class="ceo-featured-item-container">
                        <ng-template [ngIf]="categoryGroup.featureArticles.length > 0">
                            <div class="custom-padding">
                                <h2>Focus {{selectedCategory}}</h2>
                                <!--FEATURE CATEGORY DATA-->
                                <div class="carousel slide feature-article--carousel" id="featuredArticlesMobileCarousel" data-ride="carousel" data-interval="3000">
                                <!-- Indicators -->
                                <ol class="carousel-indicators">
                                    <li *ngFor="let article of categoryGroup?.featureArticles; let i = index"
                                        data-target="#featuredArticlesMobileCarousel" attr.data-slide-to="{{ i }}" class="{{ i === 0 ? 'active' : '' }}">
                                    </li>
                                </ol>
                                    <!-- Wrapper for slides -->
                                    <div class="carousel-inner margin-top-40 margin-bottom-20">
                                        <div class="carousel-item" *ngFor="let featureArticle of categoryGroup?.featureArticles; let i = index" [ngClass]="{ active: i === 0 }">
                                            <app-article-card [hideDecription]="true" [article]="featureArticle"></app-article-card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    <!--SEARCH-->
                    <ng-template [ngIf]="categoryGroup.articles.length > 0">
                        <div class="article-search--container">
                                <div class="form-group">
                                    <label for="search-input" class="search-label">
                                        Search
                                        <span class="sr-only"> Enter text to filter the list of articles. Search results will be announced automatically. </span>
                                    </label>
                                    <!-- appearance="standard" temp -->
                                    <mat-form-field class="search-form-input" >
                                        <input id="search-input" placeholder="Search" matInput [(ngModel)]="searchText" name="search" #search="ngModel">
                                        <img *ngIf="searchText?.length===0" matSuffix src="assets/icons/search_icon_white.png" alt="Search" />
                                        <button class="text-semi-light" *ngIf="searchText?.length!==0" matSuffix  type="button"  mat-icon-button (click)="searchText=''" >
                                            <span class="material-icons">clear</span>
                                        </button>
                                    </mat-form-field>
                                    <span
                                    class="sr-only"
                                    role="status"
                                    *ngIf="searchText?.length > 0">

                                    {{
                                        (categoryGroup.articles | searchFilter:['title','shortDesc']:searchText)?.length
                                    }}
                                    result(s) found.

                                    </span>
                                </div>
                        </div>
                        
                        <div class="no-article font-20" *ngIf="(categoryGroup.articles | searchFilter:['title', 'shortDesc']:searchText)?.length === 0 ">No result Found!!!</div>
                        <!---CATEGORY DATA-->

                        <ng-template ngFor let-article [ngForOf]="categoryGroup.articles | searchFilter:['title', 'shortDesc']:searchText">
                            <div class="tab-item-container article-card--row">
                                <app-article-card [hideDecription]="true" [article]="article"></app-article-card>
                            </div>
                        </ng-template>
                        <div *ngIf="viewLimit!==categoryGroup.articles.length && (categoryGroup.articles | searchFilter:['title', 'shortDesc']:searchText).length > 0" class="ceo-article-button-item">
                            <hr class="seperator-width">
                                <button type="button" class="btn btn-primary btn-md" [attr.aria-label]="'View all ' + selectedCategory" (click)="onViewMore()">
                                    View All
                                </button>
                        </div>
                    </ng-template>
    </div> 
    <ng-template [ngIf]="!categoryGroup.featureArticleRows.length && !categoryGroup.articleRows.length">
        <div class="no-article">
            None at this time
        </div>
    </ng-template>
</div>